import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  EMPLOYEE_LEVELS_GET_REQUEST,
  EMPLOYEE_LEVELS_GET_SUCCESS,
  EMPLOYEE_LEVELS_GET_FAILURE,
  EMPLOYEE_LEVELS_GET_RESET,
  EMPLOYEE_LEVELS_LIST_REQUEST,
  EMPLOYEE_LEVELS_LIST_SUCCESS,
  EMPLOYEE_LEVELS_LIST_FAILURE,
  EMPLOYEE_LEVELS_LIST_RESET,
  EMPLOYEE_LEVELS_CREATE_REQUEST,
  EMPLOYEE_LEVELS_CREATE_SUCCESS,
  EMPLOYEE_LEVELS_CREATE_FAILURE,
  EMPLOYEE_LEVELS_CREATE_RESET,
  EMPLOYEE_LEVELS_EDIT_REQUEST,
  EMPLOYEE_LEVELS_EDIT_SUCCESS,
  EMPLOYEE_LEVELS_EDIT_FAILURE,
  EMPLOYEE_LEVELS_EDIT_RESET,
  EMPLOYEE_LEVELS_DEACTIVATE_REQUEST,
  EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS,
  EMPLOYEE_LEVELS_DEACTIVATE_FAILURE,
  EMPLOYEE_LEVELS_DEACTIVATE_RESET,
  EMPLOYEE_LEVELS_EXPORT_REQUEST,
  EMPLOYEE_LEVELS_EXPORT_SUCCESS,
  EMPLOYEE_LEVELS_EXPORT_FAILURE,
  EMPLOYEE_LEVELS_EXPORT_RESET,
} from './../../constants'

export function createEmployeeLevels(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels`,
      method: 'POST',
      types: [
        EMPLOYEE_LEVELS_CREATE_REQUEST,
        EMPLOYEE_LEVELS_CREATE_SUCCESS,
        EMPLOYEE_LEVELS_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getEmployeeLevels(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels`,
      method: 'GET',
      types: [
        EMPLOYEE_LEVELS_LIST_REQUEST,
        EMPLOYEE_LEVELS_LIST_SUCCESS,
        EMPLOYEE_LEVELS_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getEmployeeLevelsByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels/${id}`,
      method: 'GET',
      types: [
        EMPLOYEE_LEVELS_GET_REQUEST,
        EMPLOYEE_LEVELS_GET_SUCCESS,
        EMPLOYEE_LEVELS_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editEmployeeLevels(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels/${id}`,
      method: 'PUT',
      types: [
        EMPLOYEE_LEVELS_EDIT_REQUEST,
        EMPLOYEE_LEVELS_EDIT_SUCCESS,
        EMPLOYEE_LEVELS_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivateEmployeeLevels(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels/${id}/delete`,
      method: 'PUT',
      types: [
        EMPLOYEE_LEVELS_DEACTIVATE_REQUEST,
        EMPLOYEE_LEVELS_DEACTIVATE_SUCCESS,
        EMPLOYEE_LEVELS_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}
export function exportEmployeeLevels(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/employee-levels/exports`,
      method: 'GET',
      types: [
        EMPLOYEE_LEVELS_EXPORT_REQUEST,
        EMPLOYEE_LEVELS_EXPORT_SUCCESS,
        EMPLOYEE_LEVELS_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function resetListEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_LIST_RESET,
  }
}


export function resetCreateEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_CREATE_RESET,
  }
}

export function resetEditEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_EDIT_RESET,
  }
}

export function resetGetEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_GET_RESET,
  }
}

export function resetDeactivateEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_DEACTIVATE_RESET,
  }
}
export function resetExportEmployeeLevels() {
  return {
    type: EMPLOYEE_LEVELS_EXPORT_RESET,
  }
}



// WEBPACK FOOTER //
// ./src/actions/employee-levels/employee-levels-action.js